export const parseURL = (url: string): HTMLAnchorElement => {
  const a = document.createElement('a')
  a.href = url
  return a
}

export const getScriptTag = (doc: Document = document): HTMLScriptElement | undefined =>
  doc.getElementById('mol-ads-cmp') as HTMLScriptElement

export const getScriptBaseURL = (cmpScript: HTMLScriptElement | undefined = getScriptTag()): string =>
  cmpScript ? parseURL(cmpScript.src).origin : ''
